<template>
    <div :style="{ backgroundColor:theme }" v-if="$config('showNavBar')">
        <div v-if="isIOS" :style="{height: '20px'}"></div>
        <header class="bar" :style="{height: isIOS?'44px':'50px'}">
            <div class="bar-back">
                <div @click="$pop()" v-if="back">
                    <yd-navbar-back-icon color="#fff"></yd-navbar-back-icon>
                </div>
            </div>

            <div style="flex: 1" class="bar-title">
                <slot name="title">
                    <span :style="{ color:tintColor }">{{title}}</span>
                </slot>
            </div>


            <div class="bar-right">
                <slot name="right">
                </slot>
            </div>
        </header>
        <!--<yd-navbar :title="title" :bgcolor="theme" :color="tintColor" fontsize=".36rem"-->
        <!--:style="{ fontWeight:'bold', height:'44px', backgroundColor:'#f8d766' }"-->
        <!--v-if="$config('showNavBar')">-->
        <!--<div @click="$pop()" slot="left" v-if="back">-->
        <!--<yd-navbar-back-icon color="#fff"></yd-navbar-back-icon>-->
        <!--</div>-->
        <!--</yd-navbar>-->
    </div>
</template>

<script>
    import {isIOS} from  './tools'
    export default {
        name: 'NavBar',
        components: {},
        props: {
            title: {
                type: String,
                default: '标题',
            },
            back: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                theme: this.$config('theme'),
                height: isIOS ? '44px' : '50px',
                tintColor: this.$config('themeTintColor'),
                isIOS,
            }
        },
        computed: {
            // userInfo: ({user}) => user.userInfo,
        },
        created: function () {

        },
        methods: {
            popRoute: function () {

            }
        }
    }
</script>

<style scoped>
    .yd-navbar:after {
        border-bottom: 0px !important;
    }

    .bar {
        display: flex;
        flex-direction: row;
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .bar-back {
        display: flex;
        align-items: center;
        justify-content: center;
        /*padding-left: .2rem;*/
        /*background-color: crimson;*/
        width: .8rem;
    }

    .bar-right {
        width: .8rem;
        display: flex;
        align-items: center;
    }

    .bar-title {
        /*background-color: white;*/
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .36rem;
        font-weight: bold
        /*background-color: aqua;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue